(function () {
  var leafletLoading = false;
  var leafletCallbacks = [];
  var GEO_OPTIONS = { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 };

  /* Langue de la page : les messages ci-dessous étaient écrits en français seulement
     (audit du 27/09/2026 : « Le plus proche de vous… », « Adresse introuvable » sur /en). */
  var EN = !/^fr/i.test(document.documentElement.lang || '');

  function ensureLeaflet(callback) {
    if (typeof window.L !== 'undefined') {
      callback();
      return;
    }

    leafletCallbacks.push(callback);
    if (leafletLoading) return;
    leafletLoading = true;

    if (!document.querySelector('link[href*="leaflet.css"]')) {
      var stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      stylesheet.integrity = 'sha384-sHL9NAb7lN7rfvG5lfHpm643Xkcjzp4jFvuavGOndn6pjVqS6ny56CAt3nsEVT4H';
      stylesheet.crossOrigin = 'anonymous';
      document.head.appendChild(stylesheet);
    }

    var script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.integrity = 'sha384-cxOPjt7s7Iz04uaHJceBmS+qpjv2JkIHNVcuOrM+YHwZOmJGBXI00mdUXEq65HTH';
    script.crossOrigin = 'anonymous';
    script.onload = function () {
      leafletLoading = false;
      leafletCallbacks.splice(0).forEach(function (callback) { callback(); });
    };
    document.head.appendChild(script);
  }

  function setText(el, value) {
    if (!el) return;
    el.textContent = value == null ? '' : value;
  }

  function toggleVisible(el, visible) {
    if (!el) return;
    if (visible) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  function updateMainCard(section, data) {
    var main = section.querySelector('[data-mm-cl-main]');
    if (!main) return;

    setText(main.querySelector('[data-mm-cl-name]'), data.name || '');

    var addr = main.querySelector('[data-mm-cl-addr]');
    setText(addr, data.address || '');
    toggleVisible(addr, !!data.address);

    var hoursWrap = main.querySelector('[data-mm-cl-hours-wrap]');
    setText(main.querySelector('[data-mm-cl-status]'), data.status || (window.mmI18n && window.mmI18n.locOpen) || 'OUVERT');
    setText(main.querySelector('[data-mm-cl-hours]'), data.hours ? '\u00b7 ' + data.hours : '');
    toggleVisible(hoursWrap, !!(data.hours));

    var emailWrap = main.querySelector('[data-mm-cl-email-wrap]');
    setText(main.querySelector('[data-mm-cl-email]'), data.email || '');
    toggleVisible(emailWrap, !!data.email);

    var phoneWrap = main.querySelector('[data-mm-cl-phone-wrap]');
    setText(main.querySelector('[data-mm-cl-phone]'), data.phone || '');
    toggleVisible(phoneWrap, !!data.phone);

    var phoneBtn = main.querySelector('[data-mm-cl-phone-btn]');
    if (phoneBtn) {
      if (data.phone) {
        phoneBtn.setAttribute('href', 'tel:' + data.phone.replace(/[\s+]/g, ''));
        phoneBtn.removeAttribute('hidden');
      } else {
        phoneBtn.setAttribute('hidden', '');
      }
    }

    var emailBtn = main.querySelector('[data-mm-cl-email-btn]');
    if (emailBtn) {
      if (data.email) {
        emailBtn.setAttribute('href', 'mailto:' + data.email);
        emailBtn.removeAttribute('hidden');
      } else {
        emailBtn.setAttribute('hidden', '');
      }
    }

    var siteBtn = main.querySelector('[data-mm-cl-site-btn]');
    if (siteBtn) {
      if (data.site) {
        siteBtn.setAttribute('href', data.site);
        siteBtn.removeAttribute('hidden');
      } else {
        siteBtn.setAttribute('hidden', '');
      }
    }

    var itinBtn = main.querySelector('[data-mm-cl-itinerary-btn]');
    if (itinBtn) {
      if (data.itinerary) {
        itinBtn.setAttribute('href', data.itinerary);
        itinBtn.removeAttribute('hidden');
      } else {
        itinBtn.setAttribute('hidden', '');
      }
    }

    main.classList.remove('is-updated');
    void main.offsetWidth;
    main.classList.add('is-updated');
  }

  /* Distance orthodromique en kilometres. Elle sert a designer le revendeur le
     plus proche du visiteur, donc a COMPARER des distances : la formule de
     haversine suffit largement, et surtout elle ne demande aucun appel reseau.
     Le pays du visiteur se deduit de ce meme calcul — celui du revendeur le plus
     proche — plutot que d'un geocodage inverse : c'est instantane, ca marche
     hors ligne, et ca donne le bon resultat meme depuis un pays sans revendeur. */
  function distanceKm(depart, arrivee) {
    var rayonTerrestre = 6371;
    var enRadians = Math.PI / 180;
    var deltaLat = (arrivee[0] - depart[0]) * enRadians;
    var deltaLng = (arrivee[1] - depart[1]) * enRadians;
    var a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2)
      + Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2)
      * Math.cos(depart[0] * enRadians) * Math.cos(arrivee[0] * enRadians);
    return 2 * rayonTerrestre * Math.asin(Math.min(1, Math.sqrt(a)));
  }

  function readCoordinates(item) {
    var lat = parseFloat(item && item.getAttribute('data-lat'));
    var lng = parseFloat(item && item.getAttribute('data-lng'));
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    return [lat, lng];
  }

  function initMap(section) {
    var mapElement = section.querySelector('[data-mm-cl-map]');
    if (!mapElement || typeof window.L === 'undefined') return null;
    if (mapElement.dataset.mmClMapReady === 'true') return mapElement.mmClMapState || null;

    mapElement.dataset.mmClMapReady = 'true';

    var map = window.L.map(mapElement, {
      scrollWheelZoom: false,
      zoomControl: false,
      maxBoundsViscosity: 1
    });
    window.L.control.zoom({
      zoomInTitle: EN ? 'Zoom in' : 'Zoom avant',
      zoomOutTitle: EN ? 'Zoom out' : 'Zoom arrière'
    }).addTo(map);
    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      maxZoom: 19
    }).addTo(map);
    // Infobulle du lien « Leaflet » en français sur /fr (le drapeau et le lien restent).
    if (!EN && map.attributionControl && typeof map.attributionControl.options.prefix === 'string') {
      map.attributionControl.setPrefix(map.attributionControl.options.prefix.replace('A JavaScript library for interactive maps', 'Bibliothèque JavaScript de cartes interactives'));
    }

    /* Le fond gris apparaissait AU-DESSUS et EN DESSOUS des tuiles des que la
       carte etait assez dezoomee pour que le monde entier n'occupe plus toute la
       hauteur du cadre — exactement ce que produit un recadrage sur 127 points
       repartis sur cinq continents. Horizontalement le probleme n'existe pas,
       Leaflet repete les tuiles a l'infini ; verticalement la projection
       s'arrete a +/-85 degres et il n'y a rien a afficher au-dela.

       La racine est donc le zoom minimal, pas la couleur de fond : on interdit
       a la carte de descendre sous le niveau ou le monde COUVRE le cadre
       (`getBoundsZoom(monde, true)` rend precisement ce niveau), et on empeche
       de faire glisser le monde hors du cadre. Tout recadrage ulterieur,
       `fitBounds` compris, est borne par ce plancher. */
    var MONDE = window.L.latLngBounds([[-85.0511, -180], [85.0511, 180]]);
    function bornerAuMonde() {
      map.setMinZoom(map.getBoundsZoom(MONDE, true));
      map.setMaxBounds(MONDE);
    }
    bornerAuMonde();
    map.on('resize', bornerAuMonde);

    var bounds = [];
    var markers = [];
    var main = section.querySelector('[data-mm-cl-main]');
    /* Un point de vente est rendu jusqu'a deux fois — dans le panneau des
       revendeurs proches ET dans la modale complete — et les deux rendus portent
       le meme contrat data-*. La carte les prend donc TOUS, dedoublonnes par
       data-handle : sans ca, elle ne montrait que les quelques revendeurs du
       panneau alors que la liste en annonce plus de cent. */
    var vus = Object.create(null);
    var dealerItems = Array.prototype.filter.call(
      section.querySelectorAll('[data-mm-cl-dealer][data-lat]'),
      function (item) {
        var cle = item.getAttribute('data-handle');
        if (!cle) return true;
        if (vus[cle]) return false;
        vus[cle] = true;
        return true;
      }
    );
    // iconSize/iconAnchor a null (et non omis : divIcon retombe sinon sur son
    // defaut 12x12) : Leaflet ne pose alors aucun width/height/margin inline,
    // et la taille comme l'ancrage du marqueur viennent du seul CSS.
    var markerIcon = window.L.divIcon({
      className: 'mm-contact-locator__marker',
      html: '<span></span>',
      iconSize: null,
      iconAnchor: null
    });

    function addMarker(item, isMain) {
      var coordinates = readCoordinates(item);
      if (!coordinates) return;
      var marker = window.L.marker(coordinates, { icon: markerIcon }).addTo(map);
      marker.bindTooltip(item.getAttribute('data-name') || 'Point de vente');
      marker.on('click', function () {
        if (!isMain) {
          var button = item.querySelector('[data-mm-cl-dealer-select]');
          if (button) button.click();
        }
        map.setView(coordinates, Math.max(map.getZoom(), 14), { animate: true });
      });
      bounds.push(coordinates);
      markers.push({
        item: item,
        marker: marker,
        coordinates: coordinates,
        pays: item.getAttribute('data-country') || '',
        principal: isMain
      });
    }

    if (main) {
      var mainName = main.querySelector('[data-mm-cl-name]');
      main.setAttribute('data-name', mainName ? mainName.textContent : 'Boutique principale');
      addMarker(main, true);
    }
    dealerItems.forEach(function (item) { addMarker(item, false); });

    if (bounds.length) {
      map.fitBounds(bounds, { padding: [30, 30], maxZoom: 13 });
    } else {
      map.setView([48.8566, 2.3522], 11);
    }

    /* La taille reelle du conteneur n'est connue qu'apres la mise en page : le
       plancher de zoom se recalcule donc une fois celle-ci faite, sinon il est
       derive d'un cadre de hauteur nulle et ne borne rien. */
    window.setTimeout(function () {
      map.invalidateSize();
      bornerAuMonde();
    }, 0);

    var mapState = {
      map: map,
      userMarker: null,
      showLocation: function (latitude, longitude, label) {
        var coordinates = [latitude, longitude];
        if (mapState.userMarker) map.removeLayer(mapState.userMarker);
        mapState.userMarker = window.L.circleMarker(coordinates, {
          radius: 7,
          color: '#ffffff',
          weight: 3,
          fillColor: '#1d1d1d',
          fillOpacity: 1
        }).addTo(map);
        mapState.userMarker.bindTooltip(label || ((window.mmI18n && window.mmI18n.locPosition) || 'Votre position'));
        map.setView(coordinates, Math.max(map.getZoom(), 13), { animate: true });
      },
      /* N'epingler que les revendeurs RETENUS par les filtres de la liste, et
         recadrer dessus. L'ensemble est passe en handles, pas en pays : la carte
         doit suivre l'intersection du pays ET du texte saisi, sinon elle montre
         cinq epingles quand la liste n'annonce que deux revendeurs. Un ensemble
         absent signifie « tous ». La boutique de la marque, si elle existe, reste
         toujours visible : elle n'est pas un revendeur qu'on filtre. Le point
         supplementaire, quand il est fourni, est la position du visiteur : la vue
         doit le contenir, sinon on lui montre un pays sans lui montrer ou il se
         trouve dedans. */
      filtrerCarte: function (handlesRetenus, pointEnPlus) {
        var visibles = [];
        markers.forEach(function (entree) {
          var handle = entree.item.getAttribute('data-handle');
          if (entree.principal || !handlesRetenus || handlesRetenus[handle]) {
            if (!map.hasLayer(entree.marker)) entree.marker.addTo(map);
            visibles.push(entree.coordinates);
          } else if (map.hasLayer(entree.marker)) {
            map.removeLayer(entree.marker);
          }
        });
        if (pointEnPlus) visibles.push(pointEnPlus);
        if (!visibles.length) return;
        map.fitBounds(visibles, {
          padding: [30, 30],
          maxZoom: visibles.length < markers.length ? 11 : 13
        });
      },
      effacerPosition: function () {
        if (!mapState.userMarker) return;
        map.removeLayer(mapState.userMarker);
        mapState.userMarker = null;
      },
      points: markers
    };
    mapElement.mmClMapState = mapState;
    return mapState;
  }

  function setupLocationControls(section, mapState, surPosition, reinitialiser) {
    var form = section.querySelector('[data-mm-cl-search-form]');
    var input = section.querySelector('.mm-contact-locator__search-input');
    var geolocateButton = section.querySelector('[data-mm-cl-geolocate]');
    var searchButton = section.querySelector('.mm-contact-locator__search-submit');
    var status = section.querySelector('[data-mm-cl-geo-status]');

    if (!form || !mapState) return;

    function showStatus(message) {
      setText(status, message);
      toggleVisible(status, !!message);
    }

    /* Les deux chemins — ville saisie et position du navigateur — aboutissent au
       meme geste : poser le point, puis laisser `surPosition` choisir le pays et
       le revendeur le plus proche. Les traiter separement, c'etait deux
       comportements a maintenir pour une seule intention du visiteur. */
    function annoncerPosition(latitude, longitude, libelle) {
      mapState.showLocation(latitude, longitude, libelle);
      var proche = surPosition ? surPosition(latitude, longitude) : null;
      if (!proche) {
        showStatus('');
        return;
      }
      showStatus(EN
        ? 'Closest to you: ' + proche.nom + ' (' + proche.pays + '), about ' + proche.km + ' km away.'
        : 'Le plus proche de vous : ' + proche.nom + ' (' + proche.pays + '), à environ ' + String(proche.km).replace('.', ',') + ' km.');
    }

    if (input) {
      /* `search` couvre la croix native du champ, `input` la suppression au
         clavier : sans les deux, effacer d'un clic ne rendait rien. */
      ['input', 'search'].forEach(function (evenement) {
        input.addEventListener(evenement, function () {
          /* Une ville introuvable laisse le champ INVALIDE ; tant qu'il l'est, le
             navigateur ne déclenche plus `submit` : la recherche suivante ne partait
             jamais (audit du 27/09/2026). Toute frappe lève l'erreur. */
          this.setCustomValidity('');
          if (this.value.trim()) return;
          showStatus('');
          if (reinitialiser) reinitialiser();
        });
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var query = input ? input.value.trim() : '';
      if (!query) {
        if (input) input.focus();
        return;
      }

      if (input) input.setCustomValidity('');
      if (searchButton) searchButton.disabled = true;
      var url = 'https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&q=' + encodeURIComponent(query);
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Geocoding failed');
          return response.json();
        })
        .then(function (results) {
          if (!results.length) throw new Error('Address not found');
          annoncerPosition(parseFloat(results[0].lat), parseFloat(results[0].lon), query);
        })
        .catch(function () {
          // L'ancien « Le plus proche de vous… » ne correspond plus à la recherche.
          showStatus('');
          if (input) input.setCustomValidity(EN ? 'Address not found' : 'Adresse introuvable');
          if (input) input.reportValidity();
        })
        .finally(function () {
          if (searchButton) searchButton.disabled = false;
        });
    });

    function setBusy(busy) {
      if (!geolocateButton) return;
      if (busy) geolocateButton.setAttribute('aria-busy', 'true');
      else geolocateButton.removeAttribute('aria-busy');
    }

    // silent : localisation automatique (le visiteur n'a rien demandé), donc
    // aucun message d'erreur ; à la demande, l'échec doit au contraire se dire.
    function locateUser(silent) {
      if (!navigator.geolocation) {
        if (!silent) showStatus((window.mmI18n && window.mmI18n.locUnavailable) || 'La géolocalisation n’est pas disponible sur cet appareil.');
        return;
      }

      /* Quand le visiteur a deja refuse, le navigateur MEMORISE ce refus et
         `getCurrentPosition` echoue sans reposer la question : reessayer ne sert
         a rien, et le message generique « autorisez la geolocalisation » ne dit
         pas ou le faire. L'etat de la permission se lit sans declencher aucune
         demande, ce qui permet de nommer le blocage et le geste qui le leve. */
      if (!silent && navigator.permissions && navigator.permissions.query) {
        navigator.permissions.query({ name: 'geolocation' })
          .then(function (permission) {
            if (permission.state !== 'denied') {
              demanderPosition(silent);
              return;
            }
            showStatus(EN
              ? 'Your browser is blocking access to your location for this site. Click the padlock to the left of the address to allow it, then try again, or enter your city above.'
              : 'Votre navigateur bloque l’accès à votre position pour ce site. Ouvrez le cadenas à gauche de l’adresse pour l’autoriser, puis réessayez — ou saisissez votre ville ci-dessus.');
          })
          .catch(function () { demanderPosition(silent); });
        return;
      }

      demanderPosition(silent);
    }

    function demanderPosition(silent) {
      setBusy(true);
      navigator.geolocation.getCurrentPosition(
        function (position) {
          setBusy(false);
          annoncerPosition(position.coords.latitude, position.coords.longitude, ((window.mmI18n && window.mmI18n.locPosition) || 'Votre position'));
        },
        function () {
          setBusy(false);
          if (!silent) showStatus((window.mmI18n && window.mmI18n.locDenied) || 'Impossible d’accéder à votre position. Autorisez la géolocalisation dans votre navigateur, ou saisissez votre ville ci-dessus.');
        },
        GEO_OPTIONS
      );
    }

    if (geolocateButton) {
      geolocateButton.addEventListener('click', function () { locateUser(false); });
    }

    autoLocate(section, locateUser);
  }

  /* Position du visiteur au chargement, sans jamais provoquer de demande
     d'autorisation non sollicitée : l'audit Lighthouse « Requests the
     geolocation permission on page load » sanctionne getCurrentPosition() au
     chargement, et l'état de la permission se lit, lui, sans déclencher de
     prompt. On ne localise donc automatiquement que si l'accès est DÉJÀ
     accordé ; sinon le visiteur garde la main via le bouton. */
  function autoLocate(section, locateUser) {
    if (!section.hasAttribute('data-mm-cl-auto-locate')) return;
    if (!navigator.geolocation || !navigator.permissions || !navigator.permissions.query) return;

    navigator.permissions.query({ name: 'geolocation' })
      .then(function (permission) {
        if (permission.state === 'granted') locateUser(true);
      })
      .catch(function () {});
  }

  function initSection(section) {
    if (section.dataset.mmClReady) return;
    section.dataset.mmClReady = 'true';

    var modal = section.querySelector('[data-mm-cl-modal]');
    var openers = section.querySelectorAll('[data-mm-cl-open-modal]');
    var closers = modal ? modal.querySelectorAll('[data-mm-cl-close-modal]') : [];
    var panel = modal ? modal.querySelector('.mm-contact-locator__modal-panel') : null;
    var searchInput = modal ? modal.querySelector('[data-mm-cl-modal-search]') : null;
    var modalItems = modal ? modal.querySelectorAll('[data-mm-cl-dealer]') : [];
    var allDealerItems = section.querySelectorAll('[data-mm-cl-dealer]');
    var paysBoutons = modal ? modal.querySelectorAll('[data-mm-cl-pays]') : [];
    var listeModale = modal ? modal.querySelector('[data-mm-cl-modal-list]') : null;
    var messageVide = modal ? modal.querySelector('[data-mm-cl-modal-vide]') : null;
    var listeProches = section.querySelector('[data-mm-cl-nearby-list]');
    var itemsProches = listeProches ? listeProches.querySelectorAll('[data-mm-cl-dealer]') : [];
    var messageProchesVide = section.querySelector('[data-mm-cl-nearby-vide]');
    var limiteProches = parseInt(listeProches && listeProches.getAttribute('data-mm-cl-nearby-limit'), 10) || 3;
    /* L'ordre d'origine des deux listes, capture AVANT tout tri : sans lui, vider
       la recherche laisserait les fiches dans l'ordre de la derniere position
       connue, donc un etat que le visiteur ne peut plus defaire sans recharger. */
    var ordreInitial = {
      modale: Array.prototype.slice.call(modalItems),
      proches: Array.prototype.slice.call(itemsProches)
    };
    var lastFocus = null;

    /* Le filtre a DEUX dimensions — le texte saisi et le pays choisi — et elles
       se combinent. Les tenir dans un etat commun, applique par une seule
       fonction, est ce qui evite que taper une ville rende les revendeurs d'un
       autre pays, ou qu'un clic sur un pays efface la recherche en cours. */
    var mapState = null;
    var paysActif = '';
    var texteRecherche = '';
    var positionVisiteur = null;

    function open() {
      if (!modal) return;
      lastFocus = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      void modal.offsetWidth;
      modal.classList.add('is-open');
      document.body.classList.add('mm-cl-modal-open');
      if (panel) panel.focus();
    }

    function close(options) {
      if (!modal) return;
      /* La recherche tapée dans la fenêtre filtrait aussi la carte et la liste de la page :
         fermée par ✕ sur « zzzz », la page restait vide sans champ visible pour annuler
         (audit du 27/09/2026). Elle ne survit pas à une fermeture SANS choix ; après le choix
         d'un revendeur, elle reste (carte cadrée sur « milano », comme en ligne). */
      if (searchInput && searchInput.value && !(options && options.garderRecherche)) {
        searchInput.value = '';
        texteRecherche = '';
        appliquerFiltres();
      }
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mm-cl-modal-open');
      setTimeout(function () {
        modal.hidden = true;
        // preventScroll : rendre le focus ne doit pas annuler le défilement vers la carte.
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
      }, 320);
    }

    function remplirFiche(item) {
      updateMainCard(section, {
        name: item.getAttribute('data-name') || '',
        address: item.getAttribute('data-address') || '',
        status: item.getAttribute('data-status') || '',
        hours: item.getAttribute('data-hours') || '',
        email: item.getAttribute('data-email') || '',
        phone: item.getAttribute('data-phone') || '',
        itinerary: item.getAttribute('data-itinerary') || '',
        site: item.getAttribute('data-site') || ''
      });
    }

    /* Les deux dimensions du filtre, en un seul predicat : c'est lui qui rend
       impossible qu'une liste et la carte repondent a des criteres differents. */
    function correspond(item) {
      var texte = item.getAttribute('data-search') || '';
      var pays = item.getAttribute('data-country') || '';
      if (texteRecherche && texte.indexOf(texteRecherche) === -1) return false;
      if (paysActif && pays !== paysActif) return false;
      return true;
    }

    /* Une seule fonction applique les filtres aux DEUX listes et a la carte :
       c'est elle qui garantit que ce qui est epingle est exactement ce qui est
       liste. Les dedoubler, c'etait accepter qu'ils divergent — et ils
       divergeaient : le panneau annoncait un revendeur au Salvador pendant que
       la carte montrait Milan. */
    function appliquerFiltres() {
      var visibles = 0;
      var retenus = Object.create(null);
      modalItems.forEach(function (item) {
        if (correspond(item)) {
          item.removeAttribute('hidden');
          retenus[item.getAttribute('data-handle')] = true;
          visibles += 1;
        } else {
          item.setAttribute('hidden', '');
        }
      });
      if (messageVide) messageVide.hidden = visibles !== 0;
      if (annonce) {
        annonce.textContent = visibles === 0
          ? ((window.mmI18n && window.mmI18n.locNone) || 'Aucun revendeur ne correspond.')
          : visibles + (visibles > 1 ? ((window.mmI18n && window.mmI18n.locMany) || ' revendeurs affichés.') : ((window.mmI18n && window.mmI18n.locOne) || ' revendeur affiché.'));
      }

      /* Le panneau ne montre que les premiers retenus — dans l'ordre courant,
         donc les plus proches des qu'une position est connue. Les autres restent
         dans le DOM : ils sont indexables, et la carte s'appuie sur eux. */
      var montres = 0;
      var prochesDansLOrdre = listeProches
        ? Array.prototype.filter.call(listeProches.children, function (noeud) {
            return noeud.hasAttribute('data-mm-cl-dealer');
          })
        : [];
      prochesDansLOrdre.forEach(function (item) {
        if (montres < limiteProches && correspond(item)) {
          item.removeAttribute('hidden');
          montres += 1;
        } else {
          item.setAttribute('hidden', '');
        }
      });
      if (messageProchesVide) messageProchesVide.hidden = montres !== 0;

      Array.prototype.forEach.call(paysBoutons, function (bouton) {
        var actif = (bouton.getAttribute('data-mm-cl-pays') || '') === paysActif;
        bouton.classList.toggle('is-active', actif);
        bouton.setAttribute('aria-pressed', actif ? 'true' : 'false');
      });
      if (mapState) mapState.filtrerCarte(retenus, positionVisiteur);
    }

    function reordonner(liste, items) {
      if (!liste) return;
      items.forEach(function (item) { liste.appendChild(item); });
    }

    /* Remet la section dans son etat de premier chargement : ni pays choisi, ni
       position, ni tri. Vider le champ de recherche doit suffire a tout revoir,
       sans recharger la page. */
    function reinitialiser() {
      paysActif = '';
      positionVisiteur = null;
      reordonner(listeModale, ordreInitial.modale);
      reordonner(listeProches, ordreInitial.proches);
      if (mapState) mapState.effacerPosition();
      appliquerFiltres();
    }

    /* Le plus proche en premier : sans position connue, l'ordre des fiches est
       celui du back-office, qui n'a aucun sens pour le visiteur. */
    function trierParDistance() {
      if (!positionVisiteur) return;
      [[listeModale, modalItems], [listeProches, itemsProches]].forEach(function (paire) {
        if (!paire[0]) return;
        reordonner(paire[0], Array.prototype.slice.call(paire[1])
          .map(function (item) {
            var coordonnees = readCoordinates(item);
            return {
              item: item,
              distance: coordonnees ? distanceKm(positionVisiteur, coordonnees) : Infinity
            };
          })
          .sort(function (a, b) { return a.distance - b.distance || 0; })
          .map(function (entree) { return entree.item; }));
      });
    }

    /* Point d'entree UNIQUE de toute position connue du visiteur, qu'elle vienne
       du navigateur ou de la ville saisie. Le pays ne se demande pas a un service
       de geocodage inverse : c'est celui du revendeur le plus proche, donc une
       comparaison de distances sur des coordonnees deja en page. */
    function surPosition(latitude, longitude) {
      positionVisiteur = [latitude, longitude];
      if (!mapState) return null;
      var plusProche = null;
      var meilleure = Infinity;
      mapState.points.forEach(function (entree) {
        if (entree.principal) return;
        var distance = distanceKm(positionVisiteur, entree.coordinates);
        if (distance < meilleure) {
          meilleure = distance;
          plusProche = entree;
        }
      });
      if (!plusProche) {
        appliquerFiltres();
        return null;
      }
      paysActif = plusProche.pays;
      trierParDistance();
      appliquerFiltres();
      remplirFiche(plusProche.item);
      return {
        nom: plusProche.item.getAttribute('data-name') || '',
        pays: plusProche.item.getAttribute('data-country-label') || plusProche.pays,
        km: meilleure < 10 ? Math.round(meilleure * 10) / 10 : Math.round(meilleure)
      };
    }

    /* Le tiroir occupe 520 px a droite et laisse la carte visible a cote : choisir
       un pays s'y voit en direct. Sous 750 px il prend toute la largeur, et la
       carte qu'on vient de filtrer devient invisible — on lui rend alors la main.
       Le point de rupture est celui de la feuille de style de la section, pas un
       seuil choisi a part : deux valeurs a tenir d'accord divergeraient. */
    /* `sort` en Liquid ordonne par point de code : « États-Unis » (29 fiches, le
       plus gros pays du jeu) et « Émirats arabes unis » tombaient APRES
       « Viêt Nam », et « République tchèque » après « Royaume-Uni ». Aucun filtre
       Liquid ne sait trier selon un alphabet ; `Intl.Collator` le sait. La
       pastille qui leve le filtre garde sa premiere place. */
    if (paysBoutons.length > 2 && window.Intl && window.Intl.Collator) {
      /* Tri sur le libellé AFFICHÉ, dans la langue de la page : en anglais les pays sont
         traduits (« Germany ») et trier sur le nom français les mettait en désordre. */
      var langueTri = (document.documentElement.lang || 'fr').slice(0, 2);
      var cleTri = function (bouton) { return bouton.getAttribute('data-mm-cl-tri') || bouton.getAttribute('data-mm-cl-pays'); };
      var comparer = new window.Intl.Collator(langueTri, { sensitivity: 'base' }).compare;
      var conteneurPays = paysBoutons[0].parentNode;
      Array.prototype.slice.call(paysBoutons)
        .filter(function (bouton) { return bouton.getAttribute('data-mm-cl-pays'); })
        .sort(function (a, b) {
          return comparer(cleTri(a), cleTri(b));
        })
        .forEach(function (bouton) { conteneurPays.appendChild(bouton); });
    }

    var annonce = modal ? modal.querySelector('[data-mm-cl-annonce]') : null;
    var tiroirPleinEcran = window.matchMedia('(max-width: 749px)');

    Array.prototype.forEach.call(paysBoutons, function (bouton) {
      bouton.addEventListener('click', function () {
        paysActif = bouton.getAttribute('data-mm-cl-pays') || '';
        appliquerFiltres();
        if (tiroirPleinEcran.matches && modal && modal.classList.contains('is-open')) {
          /* Sur téléphone, choisir un pays ferme la fenêtre : une recherche sans résultat
             dans ce pays (« paris » puis France) laissait la carte vide, sans champ pour
             annuler (audit du 27/09/2026). Elle n'est gardée que si elle trouve quelqu'un. */
          var trouve = Array.prototype.some.call(allDealerItems, correspond);
          close({ garderRecherche: trouve });
        }
      });
    });

    allDealerItems.forEach(function (item) {
      var btn = item.querySelector('[data-mm-cl-dealer-select]') || item;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        remplirFiche(item);
        var main = section.querySelector('[data-mm-cl-main]');
        // Revendeur choisi : le focus va sur sa fiche (et non sur « VOIR PLUS », hors écran).
        if (main && main.hasAttribute('tabindex')) lastFocus = main;
        if (modal && modal.classList.contains('is-open')) close({ garderRecherche: true });
        if (main) {
          /* Une seule colonne (téléphone, tablette) : la carte est AU-DESSUS de la fiche ; on
             vise la carte pour voir le revendeur choisi dessus, puis sa fiche. Le décalage
             est la hauteur réelle de l'en-tête fixe (106 px en tablette) et non 80 px, qui
             laissait le nom du revendeur à moitié caché (audit du 27/09/2026). */
          var cible = main;
          var entete = document.querySelector('.mm-header-stack');
          var decalage = entete ? entete.offsetHeight + 12 : 80;
          var carte = section.querySelector('.mm-contact-locator__map');
          var rCarte = carte ? carte.getBoundingClientRect() : null;
          var rFiche = main.getBoundingClientRect();
          // La carte seulement si carte ET fiche tiennent à l'écran (pas un téléphone à l'horizontale).
          if (rCarte && rCarte.bottom <= rFiche.top + 1 && rFiche.bottom - rCarte.top <= window.innerHeight - decalage) cible = carte;
          var top = window.pageYOffset + cible.getBoundingClientRect().top - decalage;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    openers.forEach(function (b) { b.addEventListener('click', open); });
    Array.prototype.forEach.call(closers, function (b) { b.addEventListener('click', close); });

    if (modal) {
      /* Le fond cliquable (bouton « Fermer » plein écran) n'est pas une étape de tabulation,
         et Tab reste dans la fenêtre : il sortait vers la page cachée derrière (audit du
         27/09/2026, déjà le cas en ligne). */
      var fondModal = modal.querySelector('.mm-contact-locator__modal-overlay');
      if (fondModal) fondModal.setAttribute('tabindex', '-1');
      document.addEventListener('keydown', function (e) {
        if (!modal.classList.contains('is-open')) return;
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab' || !panel) return;
        var cibles = Array.prototype.filter.call(
          panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'),
          function (el) { return el.getClientRects().length > 0 && !el.closest('[hidden]'); }
        );
        if (!cibles.length) return;
        var premier = cibles[0];
        var dernier = cibles[cibles.length - 1];
        var actif = document.activeElement;
        if (!panel.contains(actif) || actif === panel) {
          e.preventDefault();
          (e.shiftKey ? dernier : premier).focus();
        } else if (e.shiftKey && actif === premier) {
          e.preventDefault();
          dernier.focus();
        } else if (!e.shiftKey && actif === dernier) {
          e.preventDefault();
          premier.focus();
        }
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        texteRecherche = this.value.trim().toLowerCase();
        appliquerFiltres();
      });
    }

    /* Un premier passage a vide : il confirme le masquage pose par le Liquid et,
       surtout, il remplit la region live, qui autrement reste muette jusqu'au
       premier filtre. */
    appliquerFiltres();

    function lancerCarte() {
      ensureLeaflet(function () {
        mapState = initMap(section);
        /* Leaflet arrive apres coup : si un filtre a deja ete pose entre-temps, la
           carte naitrait avec les 127 epingles alors que la liste en montre cinq.
           On la resynchronise sur l'etat courant des son existence. */
        if (mapState && (paysActif || texteRecherche || positionVisiteur)) appliquerFiltres();
        setupLocationControls(section, mapState, surPosition, reinitialiser);
      });
    }

    /* Carte chargée seulement à l'approche de la section (600 px avant) : sur l'accueil elle
       est aux deux tiers de la page, et Leaflet (46 Ko depuis unpkg.com) + les tuiles
       OpenStreetMap partaient au chargement, avec une tâche longue de 56 ms sur mobile
       (PageSpeed du 26/09/2026). Sur la page Points de vente, la carte est en haut : le
       chargement part aussitôt, comme avant. */
    if ('IntersectionObserver' in window) {
      var observateurCarte = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          observateurCarte.disconnect();
          lancerCarte();
        }
      }, { rootMargin: '600px 0px' });
      observateurCarte.observe(section);
    } else {
      lancerCarte();
    }
  }

  function boot() {
    document.querySelectorAll('[data-mm-contact-locator]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Éditeur de thème : changer un réglage re-rend le HTML de la section, donc
     un conteneur de carte vierge que le boot initial ne verra jamais. Sans ça,
     basculer le placement du panneau laisse le marchand devant une carte vide. */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-mm-contact-locator]');
    if (section) initSection(section);
  });
})();
